var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('button',{on:{"click":function($event){$event.stopPropagation();return _setup.handleClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.value))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }